import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
 
import { MarketModel } from '../models/market.model';
import { DataService } from '../services/data/data.service';
import { SaleService } from '../services/sale/sale.service';
 
@Injectable({
  providedIn: 'root',
})

export class MarketsResolverService implements Resolve<MarketModel[]> {


  constructor(private dataService: DataService, private saleService:SaleService) {
  }
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MarketModel[]> | Observable<never> {
    let id = route.paramMap.get('profileId');
    return this.dataService.getMarketsByOwner('open',id).pipe(
        take(1),
        mergeMap(items => {
          if (items) {
            this.saleService.convertSalesToDatePlaceSystem(items)
            return of(items);
          } else { // id not found
            return EMPTY;
          }
        })
      );
  }
}